import { useQuery, useMutation } from '@tanstack/react-query';

// Services
import { callReloadTableAction, deleteTableRow, getTableData } from './tableService';

export const TABLE_QUERY_KEY = 'table';

/**
 * Get table data
 * @param {string} path - The path of the page
 * @param {{pageNumber: number, globalFiltersKey?: GlobalFiltersKey, contexte?: string | null}} [params = { pageNumber: 1 }] - The query params
 * @param {QueriesOptions} [options = {}] - The query options
 * @returns {import('@tanstack/react-query').UseQueryResult<ApiManagerTableResponse, Error>} The table data
 */
export const useTableData = (path, params = { pageNumber: 1 }, options = {}) => {
  const { globalFiltersKey, contexte, ...tableParams } = params;

  return useQuery({
    queryKey: [TABLE_QUERY_KEY, path, contexte, params],
    queryFn: () => getTableData(path, tableParams, contexte),
    ...options,
  });
};

/**
 * Delete a table row
 * @param {import('@tanstack/react-query').UseMutationOptions<boolean, Error, { id: string, deleteUrl: string }, unknown>} [options = {}] - The mutation options
 * @returns {import('@tanstack/react-query').UseMutationResult<boolean, Error, { id: string, deleteUrl: string }, unknown>} The delete table row mutation
 */
export const useTableDeleteRowMutation = (options = {}) => useMutation({
  mutationFn: ({ deleteUrl }) => deleteTableRow(deleteUrl),
  ...options,
});

/**
 * Call reload table action (GET on actionUrl then invalidate in caller).
 * @param {import('@tanstack/react-query').UseMutationOptions<unknown, Error, { actionUrl: string }, unknown>} [options = {}] - The mutation options
 * @returns {import('@tanstack/react-query').UseMutationResult<unknown, Error, { actionUrl: string }, unknown>} The reload action mutation
 */
export const useTableReloadActionMutation = (options = {}) => useMutation({
  mutationFn: ({ actionUrl }) => callReloadTableAction(actionUrl),
  ...options,
});
